/**
 * The BE expects search query parameters in specific format. See the example below:
 *
 * const params = {
 *  arr: [123, 'string'],
 *  bool: true,
 * }
 *
 * should output -> "arr=123&arr=string&bool=true"
 *
 * @param params query paramaters for a request
 * @returns Formatted search query parameters
 */
export var customQuerySerializer = function (params) {
    var searchParams = new URLSearchParams();
    Object.entries(params).forEach(function (_a) {
        var key = _a[0], value = _a[1];
        if (Array.isArray(value)) {
            value.forEach(function (v) {
                if (v != null) {
                    searchParams.append(key, v.toString());
                }
            });
        }
        else if (value != null) {
            searchParams.append(key, value.toString());
        }
    });
    return searchParams.toString();
};

//# sourceMappingURL=customQuerySerializer.js.map
